import React, { createContext, useContext, useState, useCallback } from 'react';

interface MapPosition {
  center: [number, number];
  zoom: number;
}

interface MapContextType {
  lastPosition: MapPosition | null;
  setLastPosition: (position: MapPosition) => void;
}

// Provide default values
const defaultContext: MapContextType = {
  lastPosition: null,
  setLastPosition: () => {
    console.warn('MapProvider not found! Using default no-op setLastPosition');
  }
};

const MapContext = createContext<MapContextType>(defaultContext);

export function MapProvider({ children }: { children: React.ReactNode }) {
  const [lastPosition, setLastPosition] = useState<MapPosition | null>(null);

  const handleSetLastPosition = useCallback((position: MapPosition) => {
    setLastPosition(position);
  }, []);

  const value = {
    lastPosition,
    setLastPosition: handleSetLastPosition
  };

  return (
    <MapContext.Provider value={value}>
      {children}
    </MapContext.Provider>
  );
}

export function useMapPosition() {
  const context = useContext(MapContext);
  // Remove the error throw since we now have default values
  return context;
}